import defineMessages from "../../common/helpers/defineMessages";

const messages = defineMessages({
    newVersion: {
        id: "notification.newVersion",
    },
});

export default messages;
